/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Client-side code for search and calendar filtering (right side)
namespace('Slzr.UI.Filters', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  // Toggle a filter list between expanded/collapsed state
  $(document).on('click', '[data-action="toggle-filter-list"]', function(event) {
    const $this = $(this);
    const $listitem = $(this).closest('li');
    const $list = $(this).closest('ul');

    // Toggle visibility of additional list items
    const is_expanded = $list.data('expanded');
    $list.find('> li[data-additional]').toggle(!is_expanded);

    // Store current state
    $list.data('expanded', !is_expanded);

    // update link title and state
    const expanded_label = $this.data('expanded-label') || 'Show Less';
    const collapsed_label = $this.data('collapsed-label') || 'Show More';
    $this.html(is_expanded ? collapsed_label : expanded_label);
    $this.attr('aria-expanded', !is_expanded);

    event.preventDefault();
    return false;
  });

  // Search nearby (within X of ZIP) form
  const updateNearbyParams = function(event) {
    const near = $('[data-nearby="zip"]').val();
    const within = $('[data-nearby="within"]').val();
    return updateUrl({ near, within });
  };

  $(document).onAction('update-nearby', updateNearbyParams);

  return $(document).on('keyup', '[data-nearby="zip"]', function(event) {
    if (event.keyCode === 13) { return updateNearbyParams(event); }
  });
});